import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiAward, FiHeart, FiShield, FiPhone, FiMapPin, FiCheck, FiUser } = FiIcons;

const Home = () => {
  const ourWorkImages = [
    "https://i.ibb.co/jkxvyMmh/images-12.jpg",
    "https://i.ibb.co/C5YNKkm7/images-15.jpg",
    "https://i.ibb.co/FkSVFZ8L/images-16.jpg",
    "https://i.ibb.co/chZx3xSk/images-21.jpg",
    "https://i.ibb.co/r2HM6Xff/images-23.jpg",
    "https://i.ibb.co/fdF1mNTF/images-33.jpg",
    "https://i.ibb.co/VcsRJLBD/images-45.jpg",
    "https://i.ibb.co/Qq9WTQB/images-54.jpg"
  ];

  const features = [
    {
      icon: FiStar,
      title: "Premium Quality",
      description: "Finest gold and diamond jewelry with certified quality assurance"
    },
    {
      icon: FiAward,
      title: "Expert Craftsmanship",
      description: "Skilled artisans creating stunning pieces with attention to detail"
    },
    {
      icon: FiHeart,
      title: "Custom Designs",
      description: "Personalized jewelry designed to match your unique style"
    },
    {
      icon: FiShield,
      title: "Lifetime Warranty",
      description: "Complete protection and maintenance for your precious investments"
    }
  ];

  const categories = [
    { title: "Wedding Sets", image: "https://i.ibb.co/Qv3YVGDG/wedding-set.webp", desc: "Complete bridal elegance" },
    { title: "Gold Rings", image: "https://i.ibb.co/4gDxQn6J/gold-rings.webp", desc: "Timeless classic bands" },
    { title: "Diamond Necklaces", image: "https://i.ibb.co/d4k1JKJt/diamond-necklace.webp", desc: "Sparkling sophistication" },
    { title: "Custom Bangles", image: "https://i.ibb.co/wN84qNtJ/custom-bangles.webp", desc: "Unique handcrafted pieces" }
  ];

  const testimonials = [
    {
      name: "Sarah Ahmed",
      role: "Loyal Customer",
      text: "The custom ring they made for my wedding was absolutely breathtaking. The attention to detail and professional service at Red Rose Jewellery is unmatched in Dubai.",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "Dubai Resident",
      text: "I've been buying gold from here for years. Their prices are fair, and the quality is always top-notch. Highly recommend visiting their Satwa store.",
      rating: 5
    },
    {
      name: "Priya Patel",
      role: "Happy Client",
      text: "Friendly staff and an amazing collection of designs. They helped me repair my grandmother's necklace and it looks brand new now!",
      rating: 5
    }
  ];

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-yellow-50 to-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="space-y-8"
            >
              <div>
                <h1 className="text-4xl md:text-6xl font-bold text-gray-800 font-serif leading-tight">
                  <span className="text-yellow-600">Premium</span> Gold &<br />
                  Diamond <span className="text-yellow-600">Jewelry</span>
                </h1>
                <p className="text-xl text-gray-600 mt-6 leading-relaxed">
                  Discover exquisite handcrafted jewelry at Red Rose Jewellery in Dubai Satwa. 
                  From stunning engagement rings to elegant necklaces, we create timeless pieces 
                  that celebrate your most precious moments.
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/services"
                  className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-8 py-4 rounded-lg font-semibold hover:from-yellow-500 hover:to-yellow-600 transition-all duration-200 text-center shadow-lg"
                >
                  Explore Collection
                </Link>
                <a
                  href="tel:+971508087073"
                  className="border-2 border-yellow-400 text-yellow-600 px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 hover:text-white transition-all duration-200 text-center flex items-center justify-center space-x-2"
                >
                  <SafeIcon icon={FiPhone} className="w-5 h-5" />
                  <span>Call Now</span>
                </a>
              </div>

              <div className="flex items-center space-x-6 pt-4">
                <div className="flex items-center space-x-2">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-yellow-600" />
                  <span className="text-gray-600">Dubai Satwa</span>
                </div>
                <div className="flex items-center space-x-1">
                  {[1,2,3,4,5].map((star) => (
                    <SafeIcon key={star} icon={FiStar} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                  <span className="text-gray-600 ml-2">5.0 Rating</span>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative"
            >
              <div className="grid grid-cols-2 gap-4">
                <img
                  src="https://i.ibb.co/1tP6cNm2/images-1.jpg"
                  alt="Premium Gold Jewelry"
                  className="w-full h-64 object-cover rounded-lg shadow-lg"
                />
                <img
                  src="https://i.ibb.co/bR2gqndY/images-2.jpg"
                  alt="Diamond Rings"
                  className="w-full h-64 object-cover rounded-lg shadow-lg mt-8"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-yellow-400 rounded-full opacity-20"></div>
              <div className="absolute -top-4 -right-4 w-16 h-16 bg-yellow-500 rounded-full opacity-30"></div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Featured Categories Section (New) */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-gray-800 font-serif mb-4">
              Explore by <span className="text-yellow-600">Category</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Find the perfect piece that speaks to your style
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((cat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group relative overflow-hidden rounded-lg shadow-lg h-80 cursor-pointer"
              >
                <img 
                  src={cat.image} 
                  alt={cat.title} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent group-hover:from-black/90 transition-all duration-300 flex flex-col justify-end p-6">
                  <h3 className="text-white text-xl font-bold font-serif mb-1">{cat.title}</h3>
                  <p className="text-gray-300 text-sm transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                    {cat.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Features */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-gray-800 font-serif mb-4">
              Why Choose <span className="text-yellow-600">Red Rose</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Excellence in every carat, trust in every transaction
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
                className="text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Work Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold text-gray-800 font-serif mb-4">
              Our <span className="text-yellow-600">Masterpieces</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              A showcase of our recent custom creations and popular designs
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {ourWorkImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group relative overflow-hidden rounded-lg shadow-lg"
              >
                <img
                  src={image}
                  alt={`Jewelry piece ${index + 1}`}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </motion.div>
            ))}
          </div>
          {/* View Full Collection button removed as requested */}
        </div>
      </section>

      {/* Testimonials Section (New) */}
      <section className="py-20 bg-gray-900 text-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none">
          <div className="absolute top-10 left-10 w-64 h-64 bg-yellow-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-64 h-64 bg-yellow-600 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl font-bold font-serif mb-4">
              Client <span className="text-yellow-400">Love</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              What our valued customers say about their experience
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((review, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gray-800 p-8 rounded-xl border border-gray-700 hover:border-yellow-500/50 transition-colors duration-300"
              >
                <div className="flex text-yellow-400 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="w-5 h-5 fill-current" />
                  ))}
                </div>
                <p className="text-gray-300 mb-6 italic">"{review.text}"</p>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-yellow-600 rounded-full flex items-center justify-center text-white font-bold">
                     {review.name.charAt(0)}
                  </div>
                  <div>
                    <h4 className="font-semibold text-white">{review.name}</h4>
                    <p className="text-xs text-yellow-500">{review.role}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-yellow-400 to-yellow-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-white space-y-8"
          >
            <h2 className="text-4xl font-bold font-serif">
              Visit Our Store in Dubai Satwa
            </h2>
            <p className="text-xl max-w-3xl mx-auto opacity-90">
              Experience our complete collection in person. Our expert team is ready to help you 
              find the perfect piece or create a custom design just for you.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://maps.app.goo.gl/jEEn8MF5BUkM4oxv9"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-yellow-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 inline-flex items-center justify-center space-x-2"
              >
                <SafeIcon icon={FiMapPin} className="w-5 h-5" />
                <span>Get Directions</span>
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-yellow-600 transition-all duration-200 inline-block"
              >
                Contact Us
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;